import type { Loan } from 'app/types/loan';
import { LoanStatus } from 'app/types/loan';
import { ListingSubtype, ListingType, TransactionMode } from 'app/types/listing';

export function canAssignGuardian(loan: Loan, userId?: string) {
  return (
    loan.listing.userId === userId &&
    loan.lenderId === userId &&
    loan.borrowerId !== userId &&
    loan.listing.type === ListingType.offer &&
    loan.listing.subtype === ListingSubtype.object &&
    !loan.listing.isDonation &&
    (!loan.listing.transactionMode || loan.listing.transactionMode === TransactionMode.lend) &&
    !loan.listing.maxParticipants &&
    !loan.listing.guardianId &&
    !['deleted', 'archived'].includes(loan.listing.status) &&
    [LoanStatus.Accepted, LoanStatus.Returned].includes(loan.status) &&
    new Date(loan.start) <= new Date()
  );
}

export function readGuardianTutorialAccounts(value: string | null): string[] {
  if (!value) return [];
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.filter((id): id is string => typeof id === 'string') : [];
  } catch {
    return [];
  }
}
